import React from 'react'

import './auth-layout.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    header?: React.ReactNode
    footer?: React.ReactNode
    children: React.ReactNode
  }
>

const AuthLayout = ({className, header, footer, children, ...props}: Props) => (
  <div {...props} className={cn('AuthLayout', {}, className)}>
    {header && <div className="AuthLayout__header">{header}</div>}
    <div className="AuthLayout__main">{children}</div>
    {footer && <div className="AuthLayout__footer">{footer}</div>}
  </div>
)

export default AuthLayout
